export const TargetType = {
  Account: "Account",
  Physical: "Physical",
  Juridical: "Juridical"
};

export const PersonType = {
  All: "All",
  Physical: "Physical",
  Juridical: "Juridical"
};

export function getTargetTypeName(type) {
  return type;
}

export const PieChartColors = [
  "#f44336",
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFEB3B",
  "#FFC107",
  "#FF9800",
  "#FF5722",
  "#795548",
  "#9E9E9E",
  "#607D8B"
];

export const getAccountType = {
  Holders: "Holders",
  Questions: "Questions",
  KYC: "KYC",
  Documents: "Documents",
  InvestmentProfile: "InvestmentProfile",
  Profile: "Profile",
  SignatureSets: "SignatureSets",
  References: "References",
  BankAccounts: "BankAccounts",
  Commissions: "Commission",
  RelatedAccounts: "RelatedAccounts",
  Beneficiaries: "Beneficiaries",
  Finalize: "Finalize",
  Groups: "Groups",
  Instructions: "Instructions",
};

export const KYCConstants = {
  StockMarketKnowledge: {
    Nothing: "Nothing",
    Good: "Good",
    Expert: "Expert"
  },
  CustomerLink: {
    Option1: "Cliente Existente",
    Option2: "Referido por otro cliente",
    Option3: "Referido por AF/Director",
    Option4: "Fue cliente en el pasado de una empresa fusionada/Nobilis",
    Option5: "Sin conocimiento previo",
    Option6: 'Sucesion de otra cuenta Nobilis',
  },
  CustomerRelatedSince: {
    NewCustomer: "New Customer",
    LessThan3: "Less than 3",
    Between3And10: "Between 3 and 10",
    MoreThan10: "More than 10"
  }
};

export const InvestExperienceE = ["None", "Moderate", "Extensive"];

export const InvestExperienceQ = [
  "Zero",
  "From One To Ten",
  "From Eleven To Sixty",
  "More Tan Sixty"
];

export const InvestExperienceM = [
  "0-100 K",
  "0-500 K",
  "500K-1MM",
  "More Than 1MM"
];

export const AccountSignatureWayOfAction = {
  Joint: "Joint",
  Individual: "Individual"
};

export const AccountType = {
  Customer: "Customer",
  InBalance: "InBalance",
  Pershing: "Pershing",
  Bank: "Bank"
};

export const ArchiveTypes = {
  Company: 1,
  Account: 2,
  Person: 3
};

export const AccountWayOfAction = {
  Managed: "Managed",
  Written: "Written"
};

export const AccountUsage = {
  Indistinct: "Indistinct",
  Individual: "Individual",
  Joint: "Joint",
  "": ""
};

export const AccountHistoryProcess = {
  All: {
    value: "All",
    description: "All"
  },
  RiskProfile: {
    value: "RiskProfile",
    description: "Risk Profile"
  },
  Advisor: {
    value: "Advisor",
    description: "Advisor"
  },
  BlockUnblock: {
    value: "Block/Unblock",
    description: "Block/Unblock"
  },
  Holder: {
    value: "Holder",
    description: "Holder"
  },
  InvestorProfile: {
    value: "InvestorProfile",
    description: "Investor Profile"
  }
};

export const BankAccountType = {
  Current: "Current",
  Savings: "Savings",
  Other: "Other"
};

export const BankAccountStatus = {
  Active: "Active",
  Inactive: "Inactive"
};

export const AccountBookInfo = {
  LocalBooking: "Local Booking",
  ThirdPartyBooking: "Third Party Booking",
  Both: "Both"
};

export const CorporateEventType = {
  Split : "Split",
  Coupon : "Coupon",
  Sink : "Sink",
  Maturity : "Maturity",
  Capitalization: "Capitalization",
  Fee: "Fee",
  DerivativeMaturity: "DerivativeMaturity",
  DerivativePayment: "DerivativePayment",
  Dividend: "Dividend",
  Taxes: "Taxes",
  Call: "Call",
  Custom: "Custom",
  OtherIncome: "OtherIncome"
};

export const InstructionTarget = {
  Reinvest: "Reinvest",
  Withdraw: "Withdraw",
};
